import * as React from "react";
const SvgFiRrScarf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-scarf_svg__a)">
      <path
        fill="#062147"
        d="m21.753 17.712-4.314-4.573 2.733-2.844c.68-.71.973-1.709.779-2.673-.466-2.325-1.482-4.321-3.2-6.281a1 1 0 0 0-.143-.135c-.161-.124-1.686-1.207-5.61-1.207-3.922 0-5.447 1.083-5.608 1.207q-.078.06-.144.135C4.56 3.265 3.515 5.328 3.048 7.646a3.01 3.01 0 0 0 .783 2.679l2.812 2.911-4.362 4.478a3.005 3.005 0 0 0 .065 4.233l1.24 1.208c.565.55 1.306.851 2.092.851h.053a2.98 2.98 0 0 0 2.11-.919l4.167-4.297 4.13 4.277c.559.582 1.31.91 2.116.924h.054c.786 0 1.526-.301 2.09-.851l1.26-1.227a3.015 3.015 0 0 0 .095-4.204zM18.729 8.91l-2.664 2.772-2.56-2.713 4.069-4.493c.686 1.115 1.162 2.27 1.416 3.54.065.322-.033.657-.261.894M7.659 2.766C7.957 2.6 9.223 2 12 2c2.809 0 4.072.613 4.337.761.016.018.027.037.043.056l-2.963 3.274a13.4 13.4 0 0 0-2.642-.017L7.657 2.77zM5.012 8.041c.264-1.312.73-2.5 1.438-3.638l11.782 12.49-2.72 2.646L5.272 8.938a1 1 0 0 1-.26-.897m.688 13.966a.95.95 0 0 1-.714-.283l-1.242-1.209a1 1 0 0 1-.025-1.408l.712-.731 2.673 2.602-.7.721a1 1 0 0 1-.704.308m2.796-2.464-2.67-2.599 2.21-2.268 2.585 2.676zm11.77.94-1.26 1.227a.98.98 0 0 1-.714.283 1 1 0 0 1-.708-.312l-.68-.703 2.702-2.63.693.734c.37.395.356 1.022-.032 1.4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-scarf_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrScarf;
